export enum TEAM_MEMBER_STATUS {
  ACTIVE = 'active',
  PENDING = 'pending',
}

export enum TEAM_MUTATION_TYPE {
  INVITE = 'invite',
  REMOVE = 'remove',
  CANCEL = 'cancel',
}
